<div>
  @if (addendumLogs().length > 0) {
    <div class="flex flex-col gap-4">
      @for (log of addendumLogs(); track log.id) {
        <p-card class="rounded-2xl overflow-hidden shadow-none border border-gray-200">
          <ng-template #header>
            <div class="flex items-center gap-3 p-3 bg-white">
              <div>
                <h3 class="text-lg m-0">{{ log.userName }}</h3>
                <span class="text-sm text-gray-500">
                  {{ log.createdAt | date: 'MM/dd/yyyy, h:mm a' }}
                </span>
              </div>
              <span class="ml-auto px-2 py-1 rounded bg-green-50 text-sm font-medium">Updated</span>
            </div>
          </ng-template>
          <div class="bg-gray-50 p-3 rounded-lg text-sm grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <span class="font-medium block break-words">Activity Type:</span>
              {{ log.activityType }}
            </div>
            @for (item of log.additionalInfos; track $index) {
              <div>
                <span class="font-medium block break-words">{{ item.key }}:</span>
                @if (isDate(item)) {
                  {{ item.value | date: 'MM/dd/yyyy, h:mm a' }}
                } @else {
                  {{ item.value }}
                }
              </div>
            }
          </div>
        </p-card>
      }
    </div>
  } @else {
    <div class="text-center py-8 text-gray-500">
      <p>No logs history available</p>
    </div>
  }
</div>
